import * as ko from "knockout";

ko.components.register('location-search-box', {
	viewModel: function (params) {
		var self = this;
		self.type = "LocationSearchboxComponent"

		self.rootvm = params.rootvm;

		self.id = params.id || 'location-search-' + uuidv4();
		self.search_value = ko.observable();
		self.search_value.subscribe((val) => {
			if (val === '') {
				self.selected_location(undefined)
			}
		});
		self.location_search_name = ko.observable();

		self.selected_location = params.selected_location;
		self.selected_location_callback = params.selected_location_callback;
		if (self.selected_location()) {
			self.search_value(self.selected_location().pretty_location_name());
		}

		self.delayed_search_value = ko.pureComputed(self.search_value)
			.extend({ rateLimit: { method: "notifyWhenChangesStop", timeout: 250 } });

		self.found_locations = ko.observableArray([]);
		self.is_searching = ko.observable(false);

		// Keep a log of the throttled values
		self.reset_search_value = function () {
			if (self.selected_location().location_name() == undefined) {
				self.search_value(undefined)
			}
		}

		self.delayed_search_value.subscribe(function (val) {
			// clear out our filtersa
			var location_search = self.search_value();
			self.location_search_name(location_search);

			self.search_locations();
		});

		self.option_select = function (option) {
			self.selected_location(option);
			self.selected_location().location_name.subscribe(self.reset_search_value);

			self.search_value(option.pretty_location_name())

			if (self.selected_location_callback !== undefined) {
				self.selected_location_callback(option);
			}
		};

		if (self.selected_location()) {
			self.selected_location().location_name.subscribe(self.reset_search_value);
		}

		self.search_locations = function () {
			var search_term = self.location_search_name();
			if (search_term === '') return;
			self.is_searching(true);

			return $.ajax({
				url: '/api/location/search',
				type: 'GET',
				cache: true,
				data: {
					search: self.location_search_name(),
					lang: 'de'
				},

				contentType: "application/json; charset=utf-8",
				success: function (data) {
					// there could be multiple searches, so just the most
					// recent
					if (self.location_search_name() == search_term) {
						self.found_locations(data.locations?.map((x) => {
							x.rootvm = self.rootvm
							return new Location(x);
						}));
					}
				},
				error: function (data) {
					self.is_searching(false);
				},
				complete: function () {
					if (search_term == self.location_search_name()) {
						self.is_searching(false);
					}
				}
			});

		}


	},
	template: `
		<div>
			<div data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				<div class="form-floating">
					<input autocomplete="off" class="form-control" type="text" placeholder="city" data-bind="
						attr: { id: id },
						textInput: search_value"
					/>
					<label data-bind="attr: {for: id }">Location</label>
					<div style="top: 3px;right: 3px;" class="mdi mdi-18px mdi-spin mdi-loading text-primary position-absolute"
						data-bind="visible: is_searching"
					></div>
				</div>
			</div>
			<div class="dropdown-menu" data-bind="visible: found_locations().length > 0">
				<!-- ko foreach: found_locations -->
				<button type="button" class="d-flex dropdown-item sc-dropdown-item px-3 gap-1" data-bind="click:$parent.option_select">
						<div class="text-muted mdi mdi-map-marker"></div>
						<div data-bind="text:location_name"></div>
						<div class="small text-muted text-uppercase" data-bind="text:country_abr"></div>
				</button>
				<!-- /ko -->
			</div>
		</div>`
});

